import {
  Checkbox,
  Paper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from '@mui/material';
import { t } from 'i18next';
import TableComments from './tableItems/TableComments';

const FinalReviewTable = ({
  uiURL,
  pecrId,
  headers = [],
  rows = [],
  TextAsLink,
  onDownloadExecutingFileClick,
  StyledTableCell,
  StyledTableRow,
  dispatch,
  selectedRows = [],
  onRowSelect,
}) => (
  <TableContainer component={Paper}>
    <Table aria-label="customized table">
      <TableHead>
        <TableRow>
          <StyledTableCell align="center" padding="checkbox">
            {/* Header for checkbox column */}
          </StyledTableCell>
          {headers.map((header, index) => (
            <StyledTableCell key={index} align="center">
              {t(header)}
            </StyledTableCell>
          ))}
        </TableRow>
      </TableHead>
      <TableBody>
        {rows.map((data, index) => {
          const isSelected = selectedRows.some(
            row =>
              row.DeptID === data.DeptID &&
              row.EIndex === data.EIndex &&
              row.SiteID === data.SiteID
          );
          return (
            <StyledTableRow key={index}>
              <StyledTableCell align="center" padding="checkbox">
                <Checkbox
                  checked={isSelected}
                  onChange={() => onRowSelect && onRowSelect(data)}
                  inputProps={{ 'aria-label': `select row ${index}` }}
                />
              </StyledTableCell>
              <StyledTableCell align="center">
                {data.SiteName || ''}
              </StyledTableCell>
              <StyledTableCell align="center">
                {data.Department || ''}
              </StyledTableCell>
              <StyledTableCell align="center">
                {data.DepartmentStatus === 'Estimated'
                  ? 'In Process'
                  : data.DepartmentStatus || ''}
              </StyledTableCell>
              <StyledTableCell align="center">
                {data.LeadName || ''}
              </StyledTableCell>
              <StyledTableCell align="center">
                {data.ExecutedDate || ''}
              </StyledTableCell>
              <StyledTableCell align="center">
                {data.EstimatedEffort ?? ''}
              </StyledTableCell>
              <StyledTableCell align="center">
                {data.ActualEffort ?? ''}
              </StyledTableCell>
              <StyledTableCell align="center">{`${data.EstimatedCost ?? ''} ${
                data.CurrencyUnit && data.ActualCost ? data.CurrencyUnit : ''
              }`}</StyledTableCell>
              <StyledTableCell align="center">{`${data.ActualCost ?? ''} ${
                data.CurrencyUnit && data.ActualCost ? data.CurrencyUnit : ''
              }`}</StyledTableCell>
              <StyledTableCell align="center">
                <TableComments
                  comments={data.ActualComments}
                  eoComments={null}
                />
              </StyledTableCell>
              <StyledTableCell align="center">
                {data.Docs && data.Docs.length > 0
                  ? data.Docs.map((document, id) => (
                      <Tooltip
                        key={id}
                        title={document}
                        componentsProps={{
                          tooltip: { sx: { fontSize: '14px' } },
                        }}
                      >
                        <Typography
                          key={id}
                          noWrap
                          style={{
                            ...TextAsLink,
                            width: 120,
                            textOverflow: 'ellipsis',
                            whiteSpace: 'nowrap',
                            display: 'inline-block',
                            verticalAlign: 'middle',
                          }}
                          onClick={() => {
                            onDownloadExecutingFileClick(
                              uiURL,
                              pecrId,
                              data.SiteID,
                              data.DeptID,
                              data.EIndex,
                              document,
                              dispatch
                            );
                          }}
                        >
                          {document}
                        </Typography>
                      </Tooltip>
                    ))
                  : ''}
              </StyledTableCell>
            </StyledTableRow>
          );
        })}
      </TableBody>
    </Table>
  </TableContainer>
);

export default FinalReviewTable;
